import React from "react";
import { t } from "i18next";

import { BANNER_BODY } from "../../constant/constant";
import FormsTab from "../forms/TabForms";

const Banner = () => {
  return (
    <div id="home-banner" className="provider-search-container">
      <div className="padding-none fluidcontainer-bg argus-banner">
        <div className="container-fluid rel-position provider-search-container">
          <div className="row">
            <div className="col-md-7 banner-upper-text">
              <h3>{t("home-page-title")}</h3>

              {BANNER_BODY &&
                BANNER_BODY.map((content, index) => (
                  <p key={index}>{t(content)}</p>
                ))}
            </div>

            <div className="col-md-5 sidebar padding-right-none">
              <FormsTab />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
